import moment from 'moment';
import React, { Fragment, PureComponent } from 'react';
import GoKids from '../../services/GoKids';
import { readPhone } from '../../helpers/format';
import PageTitle from '../../components/PageTitle';
import FormItem from '../../components/FormItem';

class FamilyPage extends PureComponent {
  state = { family: null };

  async componentDidMount() {
    const familyId = this.props.match.params.id;
    const family = await GoKids.getFamily(familyId);
    console.log(family);
    this.setState({ family });
  }

  render() {
    const { family } = this.state;
    return (
      <Fragment>
        <PageTitle title={family ? family.displayName : 'carregando...'} />
        <div className="card card-form">
          <h4 className="form-subheader">Sobre a família</h4>
          {family && <UserPersonal family={family} />}

          <h4 className="form-subheader">Mãetoristas</h4>
          {family && <FamilyTable user={family} />}
        </div>
      </Fragment>
    );
  }
}

const UserPersonal = ({ family }) => (
  <Fragment>
    <FormItem label="Nome:" className="content-info">
      {family.displayName}
    </FormItem>
    <FormItem label="E-mail:" className="content-info">
      {family.email}
    </FormItem>
    <FormItem label="Telefone:" className="content-info">
      {family.phone ? readPhone(family.phone.number) : '-'}
    </FormItem>
  </Fragment>
);

const FamilyTable = ({ user }) => (
  <div className="form-item">
    <label />
    <table className="table table-sm" style={styles.table}>
      <thead>
        <tr>
          <th>Mãetorista</th>
          <th>Crianças</th>
          <th>Data de cadastro</th>
        </tr>
      </thead>
      <tbody>
        {user.families.map(family => (
          <tr key={family._id}>
            <td>{getDriverName(family.createdBy)}</td>
            <td>{getChildrenNames(family.children)}</td>
            <td>{moment(family.createdAt).format('L LT')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const getDriverName = driver => (driver ? driver.displayName || driver.fullName || driver.name : '-');

const getChildrenNames = children => (children ? children.map(getChildName).join(', ') : '-');

const getChildName = child => {
  if (child.nickname) return `${child.name} (${child.nickname})`;
  return child.name;
};

const styles = {
  table: { flex: 1, maxWidth: 1100, fontSize: 14 }
};
export default FamilyPage;



// WEBPACK FOOTER //
// ./src/screens/family/FamilyPage.js